import { mixed, object } from "yup";
import { nonEmptyString, phoneNumber } from "@covertree/utils";
import { RelationshipToInsured } from "@api/operations.generated";

export interface ClaimReporterForm {
  firstName: string;
  lastName: string;
  relationshipToInsured: RelationshipToInsured;
  phoneNumber: string;
}

export const validation = object({
  firstName: nonEmptyString("First name"),
  lastName: nonEmptyString("Last name"),
  relationshipToInsured: mixed<RelationshipToInsured>()
    .oneOf(
      Object.values(RelationshipToInsured),
      "Relationship to insured is required"
    )
    .required("Relationship to insured is required"),
  phoneNumber: phoneNumber().required("Phone number is required"),
});
